<template>
  <div class="buy-enter-top-title"></div>
</template>
<script>
export default {
  name: 'topTitle'
}
</script>

<style lang="scss" scoped>
.buy-enter-top-title {
  width: 100%;
  background-image: url('../../../assets/images/yzxBuyEntrance/bg_price_banner.png');
  background-position: center;
  background-size: cover;
  color: #ffffff;
  height: 135px;
}

@media (min-width: 750px) and (max-width: 960px) {
  .buy-enter-top-title {
    min-height: 270px;
    // height: 500px;
  }
}
@media (min-width: 960px) {
  .buy-enter-top-title {
    min-height: 270px;
  }
}
</style>
